export default __webpack_public_path__ + "azure.2b82c938.png";